'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require('react-router');

var _classnames2 = require('classnames');

var _classnames3 = _interopRequireDefault(_classnames2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TextButton = function (_React$Component) {
  (0, _inherits3.default)(TextButton, _React$Component);

  function TextButton() {
    (0, _classCallCheck3.default)(this, TextButton);
    return (0, _possibleConstructorReturn3.default)(this, (TextButton.__proto__ || (0, _getPrototypeOf2.default)(TextButton)).apply(this, arguments));
  }

  (0, _createClass3.default)(TextButton, [{
    key: 'render',
    value: function render() {
      var _classnames;

      var styles = require('./TextButton.scss');

      var classes = (0, _classnames3.default)((_classnames = {}, (0, _defineProperty3.default)(_classnames, styles['TextButton'], true), (0, _defineProperty3.default)(_classnames, styles['TextButton--small'], this.props.small), _classnames));
      classes = classes.concat(" " + (this.props.className || ""));

      var attrs = {};
      if (this.props.onClick) attrs.onClick = this.props.onClick;
      if (this.props.tabIndex) attrs.tabIndex = this.props.tabIndex;
      if (this.props.disabled) attrs.disabled = this.props.disabled;

      return this.props.link ? _react2.default.createElement(
        'a',
        (0, _extends3.default)({ href: this.props.href, className: classes }, attrs),
        this.props.label
      ) : _react2.default.createElement(
        'button',
        (0, _extends3.default)({ className: classes }, attrs),
        this.props.label
      );
    }
  }]);
  return TextButton;
}(_react2.default.Component);

TextButton.propTypes = {
  label: _react2.default.PropTypes.string.isRequired,
  className: _react2.default.PropTypes.string,
  form: _react2.default.PropTypes.string,
  disabled: _react2.default.PropTypes.bool,
  small: _react2.default.PropTypes.bool,
  href: _react2.default.PropTypes.string,
  tabIndex: _react2.default.PropTypes.string,
  onClick: _react2.default.PropTypes.func,
  link: _react2.default.PropTypes.bool
};

exports.default = TextButton;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/TextButton/TextButton.jsx
// module id = 2692
// module chunks = 0